import { computed } from "vue";
import { AuthorizationGrantScope } from "@/graphql";
import {
  authorizationLoading,
  authorizationReady,
  authorizationSnapshot,
  authorizationStale,
  hasRight,
  hasRightOnAnySite,
} from "./authorizationState";
import { refreshAuthorization } from "./useAuthorization";

// Compatibility facade for older consumers. Authorization has one snapshot and subscription.
export function useAccessRights() {
  function firstSiteWithRight(right: string): number | undefined {
    if (!authorizationReady.value) return undefined;
    const grant = authorizationSnapshot.value?.grants.find((entry) => entry.name === right);
    return grant?.scope === AuthorizationGrantScope.SITE ? grant.siteIds[0] : undefined;
  }

  /** Null means an effective all-sites grant; an empty list never broadens a query. */
  function siteIdsWithRight(right: string): number[] | null {
    if (!authorizationReady.value) return [];
    const grant = authorizationSnapshot.value?.grants.find((entry) => entry.name === right);
    if (!grant) return [];
    return grant.scope === AuthorizationGrantScope.SITE ? grant.siteIds : null;
  }

  return {
    hasRight,
    hasRightOnAnySite,
    firstSiteWithRight,
    siteIdsWithRight,
    ready: computed(() => authorizationReady.value),
    loading: authorizationLoading,
    stale: authorizationStale,
    refresh: refreshAuthorization,
  };
}
